import { clearAuthPersistence } from '~/lib/authStorage';
export const useLogout = (destination = '/') => {
  clearAuthPersistence();

  useTokens().$reset();
  useUser().$reset();
  useCosmo().$reset();
  useOwnerStore().reset();
  useParkerStore().reset();

  return navigateTo(destination);
}
